/**
 * Copyright (C) Firstlight Media. All rights reserved.
 * All information contained herein is and remains the property of Firstlight Media.
 * The intellectual and technical concepts contained herein are proprietary
 * to Firstlight Media. Dissemination of this information or reproduction
 * of this material is strictly forbidden unless prior written permission
 * is obtained from Firstlight Media.
 */

export enum DeviceType {
  CONSOLE = 'Console',
  DESKTOP = 'DESKTOP',
  MOBILE = 'Mobile',
  SETTOP = 'Settop',
  SMARTTV = 'SmartTV',
  TABLET = 'Tablet',
  VEHICLE = 'Vehicle',
  OTHER = 'Other',
}
